/* eslint-disable object-curly-newline */
/** @jsx jsx */
import React, { PropsWithChildren, ReactNode } from 'react';
import { jsx } from '@emotion/core';

interface AccordionRowProps {
  isExpanded: boolean;
  trigger?: ReactNode;
}

const AccordionRow = ({ children, isExpanded = false, trigger }: PropsWithChildren<AccordionRowProps>) => (
  <React.Fragment>
    {trigger}
    {isExpanded && children}
  </React.Fragment>
);

export default AccordionRow;
